import { type CoreInsurancePayload, type CoreInsurance } from '@flecto/types'

import { api } from '../../../services/api'

/**
 * Create insurance.
 *
 * @endpoint POST /api/saas/me/insurances
 * @scope saas
 * @see https://flecto.dev/api-15118056
 */
export async function createInsurance(
  insurance: CoreInsurancePayload,
  start_now?: boolean
): Promise<CoreInsurance> {
  const body: CoreInsurancePayload = {
    incidence_value_cents: insurance.incidence_value_cents,
    quantity: insurance.quantity,
    start_at: start_now ? undefined : insurance.start_at,
    end_at: insurance.end_at,
    item_id: insurance.item_id,
    customer_id: Number(insurance.customer_id),
    notes: insurance.notes,
  }

  const response = await api.post(
    `/api/saas/me/insurances${start_now ? '?start_now=true' : ''}`,
    body
  )

  return response.data.insurance
}
